import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { CloudStoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { cn } from "@omni/utils/styles";
import { ReactNode, useCallback, useState } from "react";

import { ClickAndCollectContextProvider } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/clickAndCollect/context/clickAndCollect.context";
import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { option, infoLink, isBoxArticle, preferredStore } =
        useDeliveryItemContext();
    const [isStorePickerOpen, setIsStorePickerOpen] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const handleOnClose = useCallback(
        () => setIsStorePickerOpen(false),
        [setIsStorePickerOpen]
    );

    if (option.deliveryType !== DeliveryType.ClickAndCollect) {
        return null;
    }

    return (
        <ClickAndCollectContextProvider
            setIsStorePickerOpen={setIsStorePickerOpen}
        >
            <div className={cn("tw:pl-5.25", className)}>{children}</div>
            <StorePickerModal
                isOpen={isStorePickerOpen}
                type={StorePickerType.SELECT}
                storeCode={preferredStore?.code ?? null}
                displayStockLevel={!isBoxArticle}
                infoLink={infoLink}
                fixedFeatures={[StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE]}
                onSubmit={(_, close) => close?.()}
                onClose={handleOnClose}
                filterStoreType={CloudStoreType.WalkIn}
            />
        </ClickAndCollectContextProvider>
    );
};
